import React, { useEffect, useState } from "react";
import { Tooltip } from "../Tooltip";
import { MenuCol } from "../MenuCol";

import styles from "./footer.module.scss";
import miniLogoSB from "../../assets/img/miniLogoSB.svg";
import Argentina from "../../assets/img/flags/Argentina.png";
import Brasil from "../../assets/img/flags/Brasil.png";
import Chile from "../../assets/img/flags/Chile.png";
import Colombia from "../../assets/img/flags/Colombia.png";
import Peru from "../../assets/img/flags/Peru.png";
import arrowDown from "../../assets/img/arrow-down.svg";
import arrowUp from "../../assets/img/arrow-up.svg";

import mapWebsite from "./mapWebsite";

import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";

interface FooterProps {
    children?: any;
}

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                Brasil: "Brazil",
                Colômbia: "Colombia",
                Argentina: "Argentina",
                Peru: "Peru",
                Chile: "Chile",
            },
        },
        es: {
            translation: {
                Brasil: "Brazil",
                Colômbia: "Colombia",
                Argentina: "Argentina",
                Peru: "Peru",
                Chile: "Chile",
            },
        },
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});

const getYear = new Date().getFullYear();

export const Footer: React.FC<FooterProps> = ({ children }) => {
    const { t } = useTranslation();
    const [isActive, setIsActive] = useState(false);
    const query: any = document.querySelector("#FooterContent");
    const myWidth = query?.offsetWidth;

    return (
        <footer className={styles.footer} id="FooterContent">
            {/* Main */}
            <div className={styles.footer__main}>
                <div className={styles.footer__main__content}>
                    <div className={styles.footer__main__content__logo}>
                        <img
                            src={miniLogoSB}
                            alt="Superbid"
                            width="48px"
                            height="43px"
                        />
                    </div>
                    <div className={styles.footer__main__content__txt}>
                        Desde 1999, realizando eventos, conectando pessoas e
                        gerando valor de forma sustentável
                    </div>
                    <div className={styles.footer__main__content__social}>
                        <ul className={styles.social_list}>
                            <li
                                className={styles.whatsapp}
                                onClick={() =>
                                    (window.location.href =
                                        "https://api.whatsapp.com/send/?phone=551149509400&text&app_absent=0")
                                }
                            ></li>
                            <li
                                className={styles.instagram}
                                onClick={() =>
                                    (window.location.href =
                                        "https://www.instagram.com/superbidbrasil/")
                                }
                            ></li>
                            <li
                                className={styles.facebook}
                                onClick={() =>
                                    (window.location.href =
                                        "https://www.facebook.com/SuperbidBrasil/")
                                }
                            ></li>
                            <li
                                className={styles.linkedin}
                                onClick={() =>
                                    (window.location.href =
                                        "https://www.linkedin.com/company/superbid/")
                                }
                            ></li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* btn area */}
            <div className={styles.footer__btn_area}>
                <div className={styles.footer__btn_area__side}></div>
                <div
                    id="btnMenu"
                    aria-hidden="true"
                    className={styles.footer__btn_area__button}
                    onClick={() => setIsActive(!isActive)}
                >
                    <span className={styles.footer__btn_area__button__text}>
                        Mapa do site
                    </span>
                    <span className={styles.footer__btn_area__button__arrow}>
                        {isActive ? (
                            <img
                                src={arrowDown}
                                width="16px"
                                height="16px"
                                alt="Abrir"
                            />
                        ) : (
                            <img
                                src={arrowUp}
                                width="16px"
                                height="16px"
                                alt="Fechar"
                            />
                        )}
                    </span>
                </div>
                <div className={styles.footer__btn_area__side}></div>
            </div>

            {/* menu */}
            <div
                className={
                    isActive
                        ? styles.footer__menu + " " + styles.footer__menu__open
                        : styles.footer__menu + " " + styles.footer__menu__close
                }
            >
                <div className={styles.footer__menu__cols}>
                    {mapWebsite.Brasil.map((item, i) => (
                        <MenuCol
                            isMobile={myWidth <= 900 && true}
                            showList={isActive}
                            item={item}
                            key={i}
                        />
                    ))}
                </div>
            </div>

            {/* bottom */}
            <div className={styles.footer__bottom}>
                <div className={styles.footer__bottom__txt}>
                    Desde 1999, realizando eventos, conectando pessoas e gerando
                    valor de forma sustentável
                </div>

                <div className={styles.footer__bottom__content}>
                    <div className={styles.footer__bottom__flags}>
                        <ul className={styles.footer__bottom__flags__list}>
                            <li>
                                <Tooltip title={t("Brasil")}>
                                    <img
                                        src={Brasil}
                                        height="24"
                                        width="24"
                                        alt={t("Brasil")}
                                    />
                                </Tooltip>
                            </li>
                            <li>
                                <Tooltip title={t("Colômbia")}>
                                    <img
                                        src={Colombia}
                                        height="24"
                                        width="24"
                                        alt={t("Colômbia")}
                                    />
                                </Tooltip>
                            </li>
                            <li>
                                <Tooltip title={t("Argentina")}>
                                    <img
                                        src={Argentina}
                                        height="24"
                                        width="24"
                                        alt={t("Argentina")}
                                    />
                                </Tooltip>
                            </li>
                            <li>
                                <Tooltip title={t("Peru")}>
                                    <img
                                        src={Peru}
                                        height="24"
                                        width="24"
                                        alt={t("Peru")}
                                    />
                                </Tooltip>
                            </li>
                            <li>
                                <Tooltip title={t("Chile")}>
                                    <img
                                        src={Chile}
                                        height="24"
                                        width="24"
                                        alt={t("Chile")}
                                    />
                                </Tooltip>
                            </li>
                        </ul>
                    </div>

                    <div className={styles.footer__bottom__address}>
                        <p>
                            {getYear} Superbid © <small> &#8226; </small> Av.
                            Eng. Luís Carlos Berrini, 105, 4º andar - São Paulo,
                            SP <small> &#8226; </small> Termos e políticas
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};
